import { FC } from 'react';

import { Grid, Typography } from '@mui/material';

type ContactItemProps = {
    icon: JSX.Element;
    label: string;
    value: string;
    dataTestId: string;
};

const ContactItem: FC<ContactItemProps> = ({ icon, label, value, dataTestId }) => {
    return (
        <Grid
            data-testid={dataTestId}
            item
            container
            xs={12}
            sx={{
                padding: '32px 24px 24px 24px',
                display: 'flex',
                flexDirection: 'row',
                borderBottom: '0.5px solid #DADADA',
            }}
        >
            <Grid
                item
                md={4}
                xs={12}
                display="flex"
                flexDirection="row"
                gap={1}
                alignItems="center"
            >
                {icon}
                <Typography sx={{ fontSize: '16px', fontWeight: '700', color: '#575757' }}>
                    {label}
                </Typography>
            </Grid>
            <Grid item md={8} xs={12}>
                {value}
            </Grid>
        </Grid>
    );
};

export default ContactItem;
